import { GridCellProps } from '@progress/kendo-react-grid';
import React from 'react';
import { GearGridCell } from './GearGridCell';
import { linkVerticalIcon } from '@progress/kendo-svg-icons';
import { EMPTY_VALUE } from '../../../config/consts';
import { SvgIcon } from '@progress/kendo-react-common';

interface LinkCellProps extends GridCellProps {
  title?: string;
  value?: string;
}

export const LinkCell: React.FC<LinkCellProps> = props => {
  const field = props.field || EMPTY_VALUE;
  const value = props.value || props.dataItem[field];
  const title = props.title || value?.toString();

  return (
    <GearGridCell {...props} title={title}>
      {value ? (
        <a href={value.toString()} target="_blank" rel="noopener noreferrer" className="linkCell">
          <SvgIcon icon={linkVerticalIcon} size="small" />
          <span>Open the link</span>
        </a>
      ) : (
        <span>{EMPTY_VALUE}</span>
      )}
    </GearGridCell>
  );
};
